import React, { useState } from 'react';
import { Check, Lock, ShieldCheck, Mail } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
export function CheckoutSelector() {
  const [selectedCombo, setSelectedCombo] = useState<1 | 2 | 3>(2);
  const handleCheckoutClick = (comboNumber: number, title: string, price: string, link: string) => {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: `Combo ${comboNumber} - ${title}`,
        content_category: 'Pack Historia',
        value: parseFloat(price.replace('.', '')),
        currency: 'ARS'
      });
    }
    window.location.href = link;
  };
  const combos = [{
    id: 1 as const,
    title: 'COMBO 1: ESENCIAL',
    subtitle: 'Todo lo necesario para empezar',
    price: '19.990',
    originalPrice: '29.990',
    discount: '33%',
    link: 'https://checkout4.rosetadigital.com/cart/42922343399485:1'
  }, {
    id: 2 as const,
    title: 'COMBO 2: EL MÁS ELEGIDO',
    subtitle: 'La opción más completa',
    badge: 'MÁS VENDIDO',
    price: '29.990',
    originalPrice: '44.990',
    discount: '33%',
    link: 'https://checkout4.rosetadigital.com/cart/42972481945661:1'
  }, {
    id: 3 as const,
    title: 'COMBO 3: PREMIUM',
    subtitle: 'Experiencia completa + gamificación',
    price: '39.990',
    originalPrice: '59.990',
    discount: '33%',
    link: 'https://checkout4.rosetadigital.com/cart/42972492300349:1'
  }];
  const renderItems = (comboId: number) => {
    return <div className="px-3 pb-2 pt-0.5 space-y-1 border-t border-[#8B4513]/20 mt-1.5" data-id="element-8">
        <p className="font-bold text-[#D4A853] text-[10px] tracking-widest mb-1 pt-1" data-id="element-9">
          INCLUYE:
        </p>

        <div className="flex items-start gap-1.5" data-id="element-10">
          <Check className="w-3 h-3 text-[#F4E8D8]/60 mt-px flex-shrink-0" data-id="element-11" />
          <span className="text-[12px] text-[#F4E8D8]/90 leading-tight" data-id="element-12">
            Los 5 Tomos de Historia completos
          </span>
        </div>

        {comboId >= 2 && <>
            <div className="flex items-start gap-1.5" data-id="element-13">
              <Check className="w-3 h-3 text-[#D4A853] mt-px flex-shrink-0" data-id="element-14" />
              <span className="text-[12px] font-bold text-[#D4A853] leading-tight" data-id="element-15">
                Banco de Actividades y Evaluaciones
              </span>
            </div>
            <div className="flex items-start gap-1.5" data-id="element-16">
              <Check className="w-3 h-3 text-[#D4A853] mt-px flex-shrink-0" data-id="element-17" />
              <span className="text-[12px] font-bold text-[#D4A853] leading-tight" data-id="element-18">
                Trabajos Prácticos listos para usar
              </span>
            </div>
          </>}

        {comboId === 3 && <div className="flex items-start gap-1.5" data-id="element-19">
            <Check className="w-3 h-3 text-[#D4A853] mt-px flex-shrink-0" data-id="element-20" />
            <span className="text-[12px] font-bold text-[#D4A853] leading-tight" data-id="element-21">
              HISTORIA EN JUEGO - Propuestas Lúdicas
            </span>
          </div>}

        <div className="flex items-start gap-1.5" data-id="element-22">
          <Check className="w-3 h-3 text-[#1B7A4E] mt-px flex-shrink-0" data-id="element-23" />
          <span className="text-[12px] text-[#F4E8D8]/90 leading-tight" data-id="element-24">
            Bonus: Planificación Anual{' '}
            <span className="text-[#1B7A4E] font-semibold" data-id="element-25">(Gratis)</span>
          </span>
        </div>
        <div className="flex items-start gap-1.5" data-id="element-26">
          <Check className="w-3 h-3 text-[#1B7A4E] mt-px flex-shrink-0" data-id="element-27" />
          <span className="text-[12px] text-[#F4E8D8]/90 leading-tight" data-id="element-28">
            Bonus: Líneas de Tiempo y Esquemas{' '}
            <span className="text-[#1B7A4E] font-semibold" data-id="element-29">(Gratis)</span>
          </span>
        </div>
        <div className="flex items-start gap-1.5" data-id="element-30">
          <Check className="w-3 h-3 text-[#1B7A4E] mt-px flex-shrink-0" data-id="element-31" />
          <span className="text-[12px] text-[#F4E8D8]/90 leading-tight" data-id="element-32">
            Bonus: ChatGPT IA para Docentes{' '}
            <span className="text-[#1B7A4E] font-semibold" data-id="element-33">(Gratis)</span>
          </span>
        </div>

        <div className="flex items-center gap-1.5 pt-0.5 opacity-50" data-id="element-34">
          <Mail className="w-3 h-3 flex-shrink-0" data-id="element-35" />
          <span className="text-[11px]" data-id="element-36">
            Material digital (PDF) — por email
          </span>
        </div>
      </div>;
  };
  const selectedData = combos.find(c => c.id === selectedCombo)!;
  return <div className="max-w-md mx-auto w-full px-2" data-id="element-37">
      <div className="bg-[#2D241E] border border-[#8B4513]/50 rounded-2xl overflow-hidden shadow-2xl" data-id="element-38">
        {combos.map(combo => {
        const isSelected = selectedCombo === combo.id;
        return <div key={combo.id} onClick={() => setSelectedCombo(combo.id)} className={`cursor-pointer transition-all duration-200 ${isSelected ? 'bg-[#3E3228]' : 'bg-[#2D241E] hover:bg-[#352C24]'} ${combo.id !== 3 ? 'border-b border-[#8B4513]/25' : ''}`} data-id="element-39">
              <div className="flex items-center gap-2.5 px-3 py-2.5" data-id="element-40">
                {/* Radio */}
                <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${isSelected ? 'border-[#D4A853]' : 'border-[#8B4513]/60'}`} data-id="element-41">
                  {isSelected && <div className="w-2 h-2 rounded-full bg-[#D4A853]" data-id="element-42" />}
                </div>

                {/* Title + Subtitle */}
                <div className="flex-1 min-w-0" data-id="element-43">
                  <h3 className={`font-serif font-bold text-[13px] sm:text-[14px] leading-tight ${isSelected ? 'text-[#F4E8D8]' : 'text-[#F4E8D8]/80'}`} data-id="element-44">
                    {combo.title}
                  </h3>
                  <p className="text-[11px] text-[#F4E8D8]/50 leading-snug italic" data-id="element-45">
                    {combo.subtitle}
                  </p>
                </div>

                {/* Price Block */}
                <div className="flex flex-col items-end flex-shrink-0" data-id="element-46">
                  {combo.badge && <span className="bg-[#D4A853] text-[#2D241E] text-[8px] font-bold px-1.5 py-[1px] rounded-sm uppercase tracking-wider mb-0.5" data-id="element-47">
                      {combo.badge}
                    </span>}
                  <div className="flex items-center gap-1" data-id="element-48">
                    <span className="text-[10px] text-[#F4E8D8]/40 line-through" data-id="element-49">
                      ${combo.originalPrice}
                    </span>
                    <span className="bg-[#1B7A4E] text-[#F4E8D8] text-[8px] font-bold px-1 py-[1px] rounded-sm" data-id="element-50">
                      {combo.discount}
                    </span>
                  </div>
                  <div className="flex items-baseline gap-0.5" data-id="element-51">
                    <span className="text-[9px] text-[#F4E8D8]/60 font-medium" data-id="element-52">
                      ARS
                    </span>
                    <span className={`font-serif font-bold text-[22px] sm:text-[26px] leading-none ${isSelected ? 'text-[#F4E8D8]' : 'text-[#F4E8D8]/80'}`} data-id="element-53">
                      {combo.price}
                    </span>
                  </div>
                </div>
              </div>

              {isSelected && renderItems(combo.id)}
            </div>;
      })}

        {/* CTA */}
        <div className="px-3 pb-3 pt-2" data-id="element-54">
          <button onClick={() => handleCheckoutClick(selectedData.id, selectedData.title, selectedData.price, selectedData.link)} className="w-full bg-[#1B7A4E] hover:bg-[#15633F] active:bg-[#0F5230] text-[#F4E8D8] font-serif font-bold text-lg py-3 rounded-xl transition-all shadow-lg shadow-[#1B7A4E]/20 uppercase tracking-wider" data-id="element-55">
            COMPRAR AHORA
          </button>

          <div className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 mt-2 text-[9px] sm:text-[10px] text-[#F4E8D8]/50 font-medium" data-id="element-56">
            <div className="flex items-center gap-0.5" data-id="element-57">
              <Lock className="w-2.5 h-2.5" data-id="element-58" />
              <span data-id="element-59">Pago Seguro</span>
            </div>
            <div className="flex items-center gap-0.5" data-id="element-60">
              <Check className="w-2.5 h-2.5" data-id="element-61" />
              <span data-id="element-62">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-0.5" data-id="element-63">
              <Mail className="w-2.5 h-2.5" data-id="element-64" />
              <span data-id="element-65">PDF por email</span>
            </div>
            <div className="flex items-center gap-0.5" data-id="element-66">
              <ShieldCheck className="w-2.5 h-2.5" data-id="element-67" />
              <span data-id="element-68">Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}